<div class="p-6">

  <!-- Encabezado -->
  <div class="flex items-center justify-between mb-6">
    <div>
      <h1 class="text-2xl font-semibold text-gray-900 dark:text-white">Carpetas de Workflows</h1>
      <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">Organiza tus workflows en carpetas</p>
    </div>
    <div class="flex gap-2">
      <a routerLink="/automation/workflows"
         class="inline-flex items-center gap-1.5 px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300 transition-colors">
        ← Workflows
      </a>
      <button *appHasPermission="'workflows:create'" (click)="openCreateModal()"
              class="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
        </svg>
        Nueva Carpeta
      </button>
    </div>
  </div>

  <!-- El éxito va por ToastService (INC_CRM_020 (2) inc11); el error queda fijo aquí. -->
  @if (error) {
    <div class="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg flex justify-between text-sm">
      <span>{{ error }}</span>
      <button (click)="error = ''">&times;</button>
    </div>
  }

  <!-- Lista de carpetas -->
  <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
    @if (loading) {
      <div class="flex justify-center py-16 text-gray-400">
        <svg class="animate-spin w-6 h-6 mr-2" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
        </svg>
        Cargando carpetas...
      </div>
    } @else if (folders.length === 0) {
      <div class="flex flex-col items-center justify-center py-16 text-gray-400">
        <svg class="w-12 h-12 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                d="M3 7a2 2 0 012-2h4l2 3h8a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V7z"/>
        </svg>
        <p class="text-lg font-medium text-gray-500 dark:text-gray-400">No hay carpetas</p>
        <p class="text-sm text-gray-400 mt-1">Crea una carpeta para organizar tus workflows.</p>
        <button *appHasPermission="'workflows:create'" (click)="openCreateModal()"
                class="mt-4 px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition-colors">
          Crear Carpeta
        </button>
      </div>
    } @else {
      <table class="w-full text-sm">
        <thead class="bg-gray-50 dark:bg-gray-700/50 border-b border-gray-200 dark:border-gray-700">
          <tr>
            <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Nombre</th>
            <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Descripción</th>
            <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Estado</th>
            <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Creado</th>
            <th class="text-right px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Acciones</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
          @for (folder of folders; track folder.id) {
            <tr class="hover:bg-gray-50 dark:hover:bg-gray-700/30 transition-colors">
              <td class="px-4 py-3">
                <div class="flex items-center gap-2">
                  <svg class="w-4 h-4 text-blue-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M3 7a2 2 0 012-2h4l2 3h8a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V7z"/>
                  </svg>
                  <span class="font-medium text-gray-900 dark:text-white">{{ folder.name }}</span>
                </div>
              </td>
              <td class="px-4 py-3 text-gray-500 dark:text-gray-400">
                {{ folder.description || '—' }}
              </td>
              <td class="px-4 py-3">
                <span [class]="folder.isActive
                  ? 'inline-flex px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-700'
                  : 'inline-flex px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-500'">
                  {{ folder.isActive ? 'Activa' : 'Inactiva' }}
                </span>
              </td>
              <td class="px-4 py-3 text-gray-500 dark:text-gray-400 text-xs">
                {{ folder.datetimeCreated | date:'dd/MM/yyyy' }}
              </td>
              <td class="px-4 py-3">
                <div class="flex items-center justify-end gap-1">
                  <button (click)="openEditModal(folder)" title="Editar"
                          [appDisableWithoutPermission]="'workflows:edit'"
                          class="p-1.5 text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-md transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                    </svg>
                  </button>
                  <!--
                    INC_CRM_020 (2) inc9 — "Inactivar"/"Activar" es ahora una acción propia, y
                    "Eliminar" borra de verdad. Eliminar solo se habilita si la carpeta ya está
                    inactiva: es el flujo en dos pasos que pide el incidente.
                  -->
                  <button (click)="toggleActive(folder)"
                          [title]="folder.isActive ? 'Inactivar' : 'Activar'"
                          [disabled]="togglingId === folder.id"
                          [appDisableWithoutPermission]="'workflows:edit'"
                          class="p-1.5 rounded-md transition-colors disabled:opacity-50"
                          [class]="folder.isActive
                            ? 'p-1.5 rounded-md transition-colors text-gray-400 hover:text-amber-600 hover:bg-amber-50'
                            : 'p-1.5 rounded-md transition-colors text-gray-400 hover:text-green-600 hover:bg-green-50'">
                    @if (folder.isActive) {
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                      </svg>
                    } @else {
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"/>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                      </svg>
                    }
                  </button>
                  <button (click)="openDeleteModal(folder)"
                          [disabled]="folder.isActive"
                          [title]="folder.isActive
                            ? 'Inactiva la carpeta antes de eliminarla'
                            : 'Eliminar'"
                          [appDisableWithoutPermission]="'workflows:delete'"
                          class="p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors disabled:opacity-40 disabled:hover:text-gray-400 disabled:hover:bg-transparent disabled:cursor-not-allowed">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
</div>

<!-- Modal: Crear carpeta -->
@if (showCreateModal) {
  <div class="fixed inset-0 z-modal flex items-center justify-center bg-black/50">
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-md mx-4 p-6">
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">Nueva Carpeta</h3>
      @if (formError) {
        <div class="mb-3 p-2 bg-red-50 border border-red-200 text-red-600 text-sm rounded">{{ formError }}</div>
      }
      <form [formGroup]="createForm" (ngSubmit)="confirmCreate()" novalidate>
        <div class="space-y-3">
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Nombre *</label>
            <input type="text" formControlName="name"
                   [class]="'w-full px-3 py-2 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white ' + (isFieldInvalid(createForm, 'name') ? 'border-red-400' : 'border-gray-200 dark:border-gray-600')"/>
            @if (isFieldInvalid(createForm, 'name')) {
              <p class="mt-1 text-xs text-red-500">El nombre es obligatorio.</p>
            }
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Descripción</label>
            <textarea formControlName="description" rows="2"
                      class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white resize-none"></textarea>
          </div>
        </div>
        <div class="flex gap-2 mt-5 justify-end">
          <button type="button" (click)="closeCreateModal()"
                  class="px-4 py-2 text-sm border border-gray-200 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700">
            Cancelar
          </button>
          <button type="submit" [disabled]="saving"
                  class="px-4 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
            {{ saving ? 'Creando...' : 'Crear Carpeta' }}
          </button>
        </div>
      </form>
    </div>
  </div>
}

<!-- Modal: Editar carpeta -->
@if (showEditModal) {
  <div class="fixed inset-0 z-modal flex items-center justify-center bg-black/50">
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-md mx-4 p-6">
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">Editar Carpeta</h3>
      @if (formError) {
        <div class="mb-3 p-2 bg-red-50 border border-red-200 text-red-600 text-sm rounded">{{ formError }}</div>
      }
      <form [formGroup]="editForm" (ngSubmit)="confirmEdit()" novalidate>
        <div class="space-y-3">
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Nombre *</label>
            <input type="text" formControlName="name"
                   [class]="'w-full px-3 py-2 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white ' + (isFieldInvalid(editForm, 'name') ? 'border-red-400' : 'border-gray-200 dark:border-gray-600')"/>
            @if (isFieldInvalid(editForm, 'name')) {
              <p class="mt-1 text-xs text-red-500">El nombre es obligatorio.</p>
            }
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Descripción</label>
            <textarea formControlName="description" rows="2"
                      class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white resize-none"></textarea>
          </div>
          <div>
            <label class="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" formControlName="isActive"
                     class="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"/>
              <span class="text-sm text-gray-700 dark:text-gray-300">Carpeta activa</span>
            </label>
            <p class="text-xs text-gray-400 dark:text-gray-500 mt-1 ml-6">
              Desactívala para ocultarla de los filtros; reactívala cuando quieras volver a usarla.
            </p>
          </div>
        </div>
        <div class="flex gap-2 mt-5 justify-end">
          <button type="button" (click)="closeEditModal()"
                  class="px-4 py-2 text-sm border border-gray-200 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700">
            Cancelar
          </button>
          <button type="submit" [disabled]="saving"
                  class="px-4 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
            {{ saving ? 'Guardando...' : 'Guardar cambios' }}
          </button>
        </div>
      </form>
    </div>
  </div>
}

<!-- Modal: Eliminar carpeta -->
@if (showDeleteModal) {
  <div class="fixed inset-0 z-modal flex items-center justify-center bg-black/50">
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-sm mx-4 p-6">
      <div class="flex items-center gap-3 mb-3">
        <div class="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0">
          <svg class="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
          </svg>
        </div>
        <div>
          <h3 class="text-base font-semibold text-gray-900 dark:text-white">Eliminar Carpeta</h3>
          <p class="text-sm text-gray-500">"{{ deletingFolder?.name }}"</p>
        </div>
      </div>
      <!--
        INC_CRM_020 (2) inc9 — el texto anterior ("los workflows no serán eliminados")
        describía el borrado suave que hacía el backend. Ahora el borrado es real y solo
        procede con la carpeta vacía, así que el aviso dice lo que de verdad ocurre.
      -->
      <p class="text-sm text-gray-600 dark:text-gray-400 mb-4">
        La carpeta se eliminará de forma permanente y esta acción no se puede deshacer.
        Solo es posible si está vacía: si todavía contiene workflows o subcarpetas, muévelos
        antes.
      </p>
      <div class="flex gap-2 justify-end">
        <button (click)="closeDeleteModal()"
                class="px-4 py-2 text-sm border border-gray-200 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700">
          Cancelar
        </button>
        <button (click)="confirmDelete()" [disabled]="deleteLoading"
                class="px-4 py-2 text-sm bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50">
          {{ deleteLoading ? 'Eliminando...' : 'Eliminar' }}
        </button>
      </div>
    </div>
  </div>
}
